<template>
    <el-col :md="24">
        <el-col :md="8">
            <el-form-item class="item-fome-base item-center" label="項目選択">
                <div class="d-flex">
                    <el-select 
                        class="w--10 bg-gray-item mr-1" 
                        placeholder="追加ボタン"
                        :value="calc_item"
                        @input="$emit('update:calc_item', $event)"
                        >
                        <el-option label="なし" value="" />
                        <el-option 
                            v-for="(item, index) in items_input" 
                            v-if="!item.field_key || !field.field_key != item.field_key"
                            :key="index" 
                            :label="item.label_name" 
                            :value="item.field_key" 
                        />
                    </el-select>
                    <el-button 
                        :disabled="!calc_item || calc_item.trim().length < 1"
                        @click="addCalcItem(calc_item, 1)" 
                        class="calculation-math-btn"
                        v-bind:class="{ 'bg-disable-button': !calc_item || calc_item.trim().length < 1 }"
                        v-html="`+`"
                    />
                </div>
            </el-form-item>
        </el-col>

        <el-col :md="6">
            <el-form-item class="item-center item-fome-base item-center" label="演算子">
                <div class="d-flex">
                    <el-select
                        class="w--10 bg-gray-item mr-1"
                        placeholder="追加ボタン"
                        :value="calc_method"
                        @input="$emit('update:calc_method', $event)"
                    >
                        <el-option
                            v-for="(item, index) in constants.CALC_METHOD"
                            :key="index"
                            :label="constants.CALC_MAP[item]"
                            :value="item" 
                        />
                    </el-select>
                    <el-button 
                        :disabled="!calc_method || calc_method.trim().length < 1" 
                        @click="addCalcItem(calc_method,2)" 
                        class="calculation-math-btn" 
                        v-bind:class="{'bg-disable-button': !calc_method || calc_method.trim().length < 1}" 
                        v-html="`+`" 
                    />
                </div>
            </el-form-item>
        </el-col>

        <el-col :md="6">
            <el-form-item class="item-center item-fome-base item-center" label="数字">
                <div class="d-flex">
                    <el-input 
                        class="bg-gray-item mr-1" 
                        placeholder="追加ボタン"  
                        @input="validCalcNumber($event)" 
                        :value="number_calc"
                    />
                    <el-button 
                        :disabled="!number_calc || number_calc.trim().length < 1" 
                        @click="addCalcItem(number_calc,3)" 
                        class="calculation-math-btn" 
                        v-bind:class="{'bg-disable-button': !number_calc || number_calc.trim().length < 1}" 
                        v-html="`+`" 
                    />
                </div>
            </el-form-item>
        </el-col>

        <el-col  class="calculation-math">
            <el-form-item class="item-fome-base" label="演算式確認:">
                <div style="width: 50%;">
                    <div class="d-flex align-items-end">
                        <div class="d-flex flex-column w-100">
                            <div 
                                v-for="(item,index) in calculation" 
                                :key="index+200" 
                                class="calculation-math-item"
                            >
                                <template v-if="item.type == 2">{{ constants.CALC_MAP[item.label] }}</template>
                                <template v-else>{{ item.label }}</template>
                            </div>
                        </div>
                        <button 
                            v-if="calculation.length > 0" 
                            @click.prevent="removeCalcItem()" 
                            style="width: 56px" 
                            class="btn-all-p ml-1 btn btn-danger text-white btn-detele-item btn-delete-calculation"
                            v-html="`x`"
                        />
                    </div>
                    <p style="color:black">{{ arrayAsString(calculation) }}</p>
                </div>

                
                <div class="text-left">
                    <label v-if="error" class="text-danger text-left"> {{ error.msg }} </label>
                </div>
            </el-form-item>
            </el-col>
    </el-col>
</template>

<script>
import * as constants from "@/core/config/constant";

export default {
    components: {},

    props: [
        "error",
        "tableFieldData",
        "field",
        "calc_item",
        "calc_method",
        "calculation",
        "form_item",
        "number_calc",
        "classes",
    ],
    data(){
        return {
            constants: constants,
            calculationTypes : constants.CALCULATION_TYPE,
            value : '',
            items_input : []
        }
    },
    async mounted(){
        this.items_input = await this.listItemCalc
        this.value = this.calc_item
    },
    computed:{
        listItemCalc(){
            const inputs = this.tableFieldData.y_items.filter(item => {
                return (
                    item.input_method == 1 
                    ||
                    ( 
                        item.input_method == 9 
                        && item.field_key !== this.field.field_key
                    )
                );
            })
            return inputs
        },
      getError(){
            console.log(`==== get error in Cacl`, this.error)
            return this.error
        }  
    },
    methods:{
        addCalcItem(value,type){
            const types = this.calculationTypes
            const formItem = this.field;
            const itemId = this.listItemCalc.find(item => item.field_key == value);
            const lastItem = this.calculation[this.calculation.length - 1]
            let obj = {}
            let itemLabel = {}
            if(type == this.calculationTypes.ITEM) {
                itemLabel = this.tableFieldData.y_items.find(item => item.field_key == value)
                obj = {
                    id : value,
                    type : type,
                    label : itemId.label_name
                }
            } else {
                obj = {
                    type : type,
                    label : value
                }
            }
            formItem.calc_flg = lastItem ? formItem.calc_flg : null
            if(formItem.calc_flg != type || formItem.calc_flg == null) {
                switch (type) {
                    case types.ITEM:
                        if (lastItem && (lastItem.label == itemLabel?.label_name || lastItem.type == types.ITEM || lastItem.type == types.VALUE)) {
                            this.$notify.error('項目・数字が連続に置いています。ご確認ください。');
                        } else {
                            formItem.calculation.push(obj)
                        }
                        break;
                    case types.CALCULATION:
                        if (['(',')'].indexOf(value) == -1 && lastItem && lastItem.label == value) {
                            this.$notify.error('演算子が連続に置いています。ご確認ください。');
                        } else {
                            formItem.calculation.push(obj)
                        }
                        break;
                
                    case types.VALUE:
                        if (lastItem && (lastItem.label == value || lastItem.type == types.ITEM || lastItem.type == types.ITEM)) {
                            this.$notify.error('項目・数字が連続に置いています。ご確認ください。');
                        } else {
                            formItem.calculation.push(obj)
                        }
                        break;
                
                    default:
                        break;
                }
                formItem.calc_flg = type
            } else {
                switch (type) {
                    case constants.CALCULATION_TYPE.ITEM:
                        if (lastItem && (lastItem.label == itemLabel.label_name || lastItem.type == constants.CALCULATION_TYPE.ITEM || lastItem.type == constants.CALCULATION_TYPE.VALUE)) {
                            this.$notify.error('項目・数字が連続に置いています。ご確認ください。');
                        } else {
                            formItem.calculation.push(obj)
                        }
                        break;
                    case constants.CALCULATION_TYPE.CALCULATION:
                        if (['(',')'].indexOf(value) == -1 && (lastItem.label == value || lastItem.label != value ) && ['+','-','X',':'].includes(lastItem.label) == true) {
                            this.$notify.error('演算子が連続に置いています。ご確認ください。');
                        } else {
                            formItem.calculation.push(obj)
                        }
                        break;
                
                    case constants.CALCULATION_TYPE.VALUE:
                        if (lastItem && (lastItem.label == value || lastItem.type == constants.CALCULATION_TYPE.ITEM || lastItem.type == constants.CALCULATION_TYPE.VALUE)) {
                            this.$notify.error('項目・数字が連続に置いています。ご確認ください。');
                        } else {
                            formItem.calculation.push(obj)
                        }
                        break;
                
                    default:
                        break;
                }
            }
            return []
        },
        validCalcNumber($event){
            let text =  $event.replace(/([^0-9])+/i, "")
            this.$emit('update:number_calc', text)
        },
        removeCalcItem() {
            this.calculation.pop()
            this.$emit('update:calculation', this.calculation)
        },
        
        updateCalcItem(val) {
            this.$emit('input', val)
        },

        arrayAsString(formItem) {
            const values = formItem.map(item => item.label);
            const characterMap = constants.CALC_MAP;
            for (let i = 0;i < values.length;i++){
                if (characterMap.hasOwnProperty(values[i])) {
                values[i] = characterMap[values[i]];
                }
            }
            const result = values.join(' ');
            return result
        },
       

    },
}
</script>

<style lang="scss" scoped>
.calculation-math-btn {
    color: white;
    border-radius: 4px;
    border-color: #EBEEF5;
    padding: 12px 5px;
    
    min-width: 41px;
    background-color: #00aff0;
    
    &:disabled {
        background-color: rgba(9, 30, 66, 0.48);
    }
}

.calculation-math {
    .calculation-math-item {
        border: 1px solid #DCDFE6;
        border-top: 0;
        color: #606266;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        width: 100%;
            word-break: break-word !important;
    word-wrap: break-word !important;
        overflow: hidden !important;

        &:first-child {
            border-top: 1px solid #DCDFE6;
        }
    }
}
</style>
